"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var React = require("react");
var ReactBootstrap = require("react-bootstrap");
var Trigger;
(function (Trigger) {
    Trigger["Click"] = "click";
    Trigger["Focus"] = "focus";
    Trigger["Hover"] = "hover";
})(Trigger = exports.Trigger || (exports.Trigger = {}));
/**
 * OverlayTrigger is used to display a component over others when triggered by something such as a hover state.
 */
var OverlayTrigger = /** @class */ (function (_super) {
    __extends(OverlayTrigger, _super);
    function OverlayTrigger() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OverlayTrigger.prototype.render = function () {
        var _a = this.props, className = _a.className, id = _a.id, style = _a.style, restProps = __rest(_a, ["className", "id", "style"]);
        return (React.createElement("div", { className: classNames('i-overlay-trigger', className), id: id, style: this.props.style },
            React.createElement(ReactBootstrap.OverlayTrigger, __assign({ container: this }, restProps))));
    };
    OverlayTrigger.Trigger = Trigger;
    return OverlayTrigger;
}(React.Component));
exports.OverlayTrigger = OverlayTrigger;
//# sourceMappingURL=OverlayTrigger.js.map